import React, {useEffect, useState} from 'react';
import {getUserFriends, selectContact} from '../../Redux/actions/contactAction';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill, RiCheckboxBlankCircleFill, RiCloseCircleLine, RiSearchLine, RiChatNewFill} from "react-icons/ri";
import {setAlert} from "../../Redux/actions/alertAction";
import {loadUser} from "../../Redux/actions/authAction";
import axios from "axios";
import {searchUserContactsRoute} from "../../utils/apiRoutes";
import PuffLoader from "react-spinners/PuffLoader";
import multiavatar from "@multiavatar/multiavatar/esm";

const ChatAccounts = ({getUserFriends, selectContact, contacts, setAlert, socket, user, loadUser}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [searchedAccounts, setSearchedAccounts] = useState([]);
    const [accountIndex, setAccountIndex] = useState(null);
    const [readMessages, setReadMessages] = useState([]);

    useEffect(() => {
        async function fetchData() {
            await getUserFriends();
        }

        fetchData();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        async function fetchData() {
            await getUserFriends();
        }

        if (!!socket && socket.current) {
            socket.current.on("msg-receive", (data) => {
                if (!!data)
                    fetchData();
            });
        }
    });

    const onFormSubmit = async (e) => {
        e.preventDefault();
        onSubmit();
    }

    const onSubmit = async (e) => {
        if (searchText.trim().length === 0) {
            setSearchedAccounts([]);
            return;
        }

        if (!searchText || searchText.trim().length < 3) {
            setAlert('At least enter 3 characters', 'error')
        } else {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            const body = JSON.stringify({email: searchText});

            try {
                const res = await axios.post(searchUserContactsRoute, body, config);
                if (res.data.length === 0)
                    setAlert('No users found', 'error')
                else
                    setSearchedAccounts(res.data);
            } catch (err) {
                const errors = err.response.data.errors;
                if (errors) {
                    errors.forEach((error) => setAlert(error.msg, 'error'));
                }
            }
        }
    }

    const accountsToShow = (contact, index) => {
        return (
            <div className='card-container' key={index} onClick={() => {
                setAccountIndex(index);
                setReadMessages([...readMessages, contact.id]);
                selectContact(contact);
            }}>
                <div
                    className={`account-container ${accountIndex === index ? "account-container-selected" : null}`}>
                    <div>
                        {
                            contact.avatarImage ?
                                <div className='avatar avatar-icon'
                                     dangerouslySetInnerHTML={{__html: multiavatar(contact.avatarImage)}}>
                                </div>
                                :
                                <RiAccountCircleFill className='avatar-icon'/>
                        }
                    </div>
                    <div className="account-detail-container">
                        <h4>{contact.name}</h4>
                        <p>{contact.email}</p>
                    </div>
                </div>

                {contact.unreadMessage && !readMessages.includes(contact.id) ?
                    <RiCheckboxBlankCircleFill className="new-message-dot"/> : null}
            </div>
        )
    }

    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <h3>Chats</h3>
                </div>

                <div className='search-box-container'>
                    <form onSubmit={(e) => onFormSubmit(e)}>
                        <div className='form-input-container'>
                            <RiSearchLine onClick={() => onSubmit()} className='form-input-icon'/>
                            <input
                                type='text'
                                className='form-input'
                                placeholder='Search Users'
                                name='searchText'
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                autoComplete="off"
                                minLength='3'
                            />
                        </div>
                    </form>
                </div>

                <div className={`${!searchedAccounts || searchedAccounts.length === 0 ? '' : 'hidden'}`}>
                    <h4>Friends</h4>
                </div>
                <div
                    className={`remove-search-container ${searchedAccounts && searchedAccounts.length > 0 ? '' : 'hidden'}`}>
                    <h4>Search</h4>
                    <RiCloseCircleLine className='close-icon' onClick={() => {
                        setSearchText('');
                        setSearchedAccounts([]);
                    }}/>
                </div>
            </div>

            <div className="all-accounts-container">
                {
                    isLoading ?
                        <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                        :
                        searchedAccounts.length > 0 ?
                            searchedAccounts.map((contact, index) =>
                                accountsToShow(contact, index)
                            )
                            :
                            contacts.length > 0 ?
                                contacts.map((contact, index) =>
                                    accountsToShow(contact, index)
                                )
                                :
                                <p>No accounts to show!</p>
                }
            </div>
        </Container>

    );
}

ChatAccounts.propTypes = {
    getUserFriends: PropTypes.func.isRequired,
    selectContact: PropTypes.func.isRequired,
    loadUser: PropTypes.func.isRequired,
    contacts: PropTypes.array,
    socket: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    contacts: state.contact.contacts,
    setAlert: PropTypes.func.isRequired,
    socket: state.auth.socket,
    user: state.auth.user,
});

export default connect(mapStateToProps, {getUserFriends, selectContact, setAlert, loadUser})(ChatAccounts);

const Container = styled.div`
  background-color: #F5F7FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;

  @media screen and (max-width: 1000px) {
    .header {
      margin-top: 59px;
    }
  }
  
  .form-input-container {
    position: relative;
    display: flex;
  }

  .header {
    padding: 12px 16px 24px 16px;
  }

  .search-box-container {
    padding: 0 16px 24px 16px;
  }

  .form-input-icon {
    color: #7a7f9a;
    padding: 0.7rem 1rem;
    font-size: 1.2rem;
    line-height: 1.5;
    white-space: nowrap;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-bottom-left-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    cursor: pointer;
  }

  .form-input {
    width: 100%;
    margin-left: -1px;
    padding: 0.5rem 0;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #7a7f9a;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .contact {
    padding: 20px 0;
    transition: 0.25s;
  }

  .isSelected {
    background-color: red !important;
  }

  .card-container {
    position: relative;

    .new-message-dot {
      color: darkRed;
      textAlign: "right";
      position: absolute;
      right: 15px;
      top: 30px
    }
  }
  
  .all-accounts-container{
    margin-top: 20px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0.2rem;

      &-thumb {
        background-color: #D1D6DB;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
  }

  .account-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.5s;
    margin: 2px auto;
    border-radius: 0.5rem;

    :hover {
      background-color: #E6EBF5;
    }
  }

  .account-detail-container {
    display: flex;
    flex-direction: column;
  }

  .avatar {
    width: 2.3rem;
    padding: 16px !important;
  }

  .avatar-icon {
    font-size: 40px;
    padding: 15px;
  }

  .account-container-selected {
    background-color: #E6EBF5;
  }

  .remove-search-container {
    display: flex;
    justify-content: space-between;

    .close-icon {
      font-size: 25px;
      cursor: pointer;
    }
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    padding-top: 25px;
    overflow: hidden;
    height: 100px;
  }

  .hidden {
    display: none !important;
  }
`;